var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.$isTab
    ? _c("div", { staticClass: "footer" }, [
        _c("div", { staticClass: "container-fluid" }, [
          _c("p", { staticClass: "trademark d-none d-sm-block" }, [
            _c("span", [
              _vm._v(
                " " +
                  _vm._s(_vm.$t("general.copyrightFooterText")) +
                  " " +
                  _vm._s(new Date().getFullYear()) +
                  " " +
                  _vm._s(_vm.$t("general.poweredByLogflows")) +
                  " "
              ),
            ]),
          ]),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }